import { ReactElement } from "react";

export default function MobileBottomNavWrapper({
  children,
}: {
  children: ReactElement;
}): JSX.Element {
  return (
    <div className="flex items-center justify-between pt-2 px-8 text-xs sm:text-sm" style={{
      paddingBottom: "calc(env(safe-area-inset-bottom, 0px) + 8px)",
    }}>
      {children}
    </div>
  );
}
